import React, { useState } from "react"
import { classNames } from "../../helpers/cssClassHelper"
import { IconContainerProps } from "../icon/IconContainer"

export interface IconButtonProps extends IconContainerProps {
    onClick: () => void
    disabled?: boolean
    tooltip?: string
}

export interface IconButtonContainerProps extends IconButtonProps {
    children: React.ReactElement<IconContainerProps>
}

export const IconButtonContainer = React.forwardRef<HTMLDivElement, IconButtonContainerProps>((props, ref) => {
    const [isHovered, setIsHovered] = useState(false)
    const [isLeaving, setIsLeaving] = useState(false)

    const containerClasses = classNames(
        "icon-button-container",
        props.disabled ? "disabled" : "",
        props.size ?? "normal",
        isHovered ? "hovered" : isLeaving ? "leaving" : ""
    )

    const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
        e.stopPropagation()
        e.preventDefault()
        if (!props.disabled) {
            props.onClick()
        }
    }

    const childWithProps = React.cloneElement(props.children, {
        size: props.size ?? "normal",
    })

    return (
        <div
            ref={ref}
            className={containerClasses}
            onClick={handleClick}
            title={props.tooltip}
            onMouseEnter={() => {
                setIsHovered(true)
                setIsLeaving(false)
            }}
            onMouseLeave={() => {
                setIsHovered(false)
                setIsLeaving(true)
            }}
            onAnimationEnd={() => setIsLeaving(false)}
        >
            {childWithProps}
        </div>
    )
})
